import api from "./axiosConfig";
import { API_ENDPOINTS } from "./apiConfig";

export async function fetchSurveyCsvBlob(clientId: number) {
  try {
    const res = await api.get(API_ENDPOINTS.surveyCsv, {
      params: { clientId },
      headers: { Accept: "text/csv" },
      responseType: "blob",
    });
    return res;
  } catch (e: any) {
    console.error(e?.message ?? "설문 CSV 다운로드 실패");
    throw e;
  }
}